export const components = {
  KeyboardShortcutsDialog: null,
  HelperButtons: null,
  DebugPanel: null,
  DebugMenu: null,
  SharePanel: null,
  TopPanel: null,
}
